import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography, Link, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

const Footer = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Typography variant="body1" align="left">
        &copy;{' '}
        <Link component="a" href="https://papillon-trade.hr/" target="_blank">
          Papillon Trade Ltd
        </Link>
        . {new Date().getFullYear()}
      </Typography>
      <Typography variant="caption">
        Papillon Trade - Your merchant traveler
      </Typography>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string
};

export default Footer;
